let IP_LOCALHOST = false
let url = ''

export const APP_TITLE = 'Aplikasi Peragaan Password Ujian Online'
// export const WS_URL = 'http://172.16.91.247:8080/ws/banksoal/base/'

if (IP_LOCALHOST) {
  url = 'http://localhost/wsuo/'
} else {
  url = '/wsuo/'
}
export const WS_URL = url



// WEBPACK FOOTER //
// ./src_suopass/config.js